<script setup>
import { ref, watch, computed } from "vue";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const props = defineProps({
  modelValue: {
    type: [String, File, null],
    default: null,
  },
  accept: {
    type: String,
    default: "image/*",
  },
});

const emit = defineEmits(["update:modelValue", "remove", "update:uploadedImage"]);

const preview = ref(null);
const fileInput = ref(null);
const displayImage = computed(() => {
  if (preview.value) {
    return {
      url: preview.value,
      name: props.modelValue.name || "Image",
    };
  }

  return props.modelValue;
});

watch(
  () => props.modelValue,
  (newValue) => {
    if (!newValue) {
      preview.value = null;
      if (fileInput.value) {
        fileInput.value.value = "";
      }
    }
  },
);

const handleFileChange = (event) => {
  const file = event.target.files[0];
  if (file) {
    emit("update:modelValue", file);
    emit("update:uploadedImage", null);
    const reader = new FileReader();
    reader.onload = (e) => {
      preview.value = e.target.result;
    };
    reader.readAsDataURL(file);
  }
};

const clearImage = () => {
  emit("update:modelValue", null);
  emit("update:uploadedImage", null);
  emit("remove");
  preview.value = null;
  if (fileInput.value) {
    fileInput.value.value = "";
  }
};
</script>

<template>
  <div class="flex flex-col items-start gap-2">
    <div
      v-if="displayImage"
      class="relative"
    >
      <div class="bg-muted flex items-center gap-2 rounded-lg border p-2 text-sm">
        <img
          :src="displayImage.url"
          class="size-10 rounded-lg object-cover"
          alt="Preview"
        />
        {{ displayImage.name }}
      </div>
      <button
        @click="clearImage"
        type="button"
        class="absolute -top-1 -right-2 rounded-full bg-red-500 p-1 text-white hover:bg-red-600"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="size-3"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clip-rule="evenodd"
          />
        </svg>
      </button>
    </div>

    <div class="flex items-center">
      <label
        :class="cn(buttonVariants({ variant: 'secondary', size: 'sm' }))"
      >
        <input
          ref="fileInput"
          type="file"
          class="hidden"
          :accept="accept"
          @change="handleFileChange"
        />
        {{ displayImage ? "Cambia Image" : "Carica Immagine" }}
      </label>
    </div>
  </div>
</template>
